import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { useStripe } from '@stripe/react-stripe-js';
import { axiosInstanceWithToken } from '@/helpers/axios';
import { successPopup } from '@/helpers';
import SidebarLayout from '@/Components/sidebar/SidebarLayout';

export const ListingStatusComponent = () => {
    const [searchParams] = useSearchParams();
    const stripe = useStripe();

    const redirect_status = searchParams.get('redirect_status');
    const paymentIntent = searchParams.get('payment_intent');
    const payment_intent_client_secret = searchParams.get('payment_intent_client_secret');
    const [statusMessage, setStatusMessage] = useState('Checking payment status...');

    useEffect(() => {
        try {
            if (redirect_status === 'succeeded' && payment_intent_client_secret && stripe) {
                const formData = new FormData();
                formData.append('payment_intent_id', paymentIntent);
                axiosInstanceWithToken.post('/payment/charge/capture', formData).then((res) => {
                    if (res?.data?.status) {
                        successPopup('', `
                            Your Payment has been approved, but Changing it to featured, it is not yet confirmed.
                            `);
                        setStatusMessage('Payment Captured.');
                    }
                })
            } else {
                // Handle other redirect_status values or missing data
                switch (redirect_status) {
                    case 'failed':
                        setStatusMessage('Payment failed.');
                        break;
                    case 'canceled':
                        setStatusMessage('Payment was canceled.');
                        break;
                    default:
                        setStatusMessage('Checking payment status....');
                        break;
                }
            }
        } catch (error) {
            console.log(error)
        }
    }, [redirect_status, payment_intent_client_secret, stripe, paymentIntent]);

    return (
        <SidebarLayout>
            <div className="max-w-md mx-auto bg-white shadow-lg rounded-lg overflow-hidden my-44 py-4">
                <div className="px-6 py-4">
                    <h2 className="text-2xl font-bold mb-2">Listing Status</h2>
                    <div className="space-y-2">
                        <div className="flex justify-between">
                            <span className="font-semibold">Status:</span>
                            <span>{statusMessage}</span>
                        </div>
                    </div>
                </div>
                <Link to={`/my_listing`} className='bg-[#8ec639] w-full text-white hover:text-white decoration-none px-4 py-2 ms-5 rounded-sm'>
                    Return to Listing Page
                </Link>
            </div>
        </SidebarLayout>
    );
};
